export const FIREBOX = {
  label: 'Firebox',
  value: 'FIREBOX'
};
export const GRATE = {
  label: 'Grate',
  value: 'GRATE'
};
